import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";


const BASE_URL = "https://sutmmg.codydeasoftech.in/api"; // ← replace with your backend base URL

const ZoneMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [zoneName, setZoneName] = useState("");

  const [filters, setFilters] = useState({ searchText: "" });

  const [zones, setZones] = useState([]); // Store API fetched data
const [page, setPage] = useState(1);
const [perPage, setPerPage] = useState(10);
const [totalRecords, setTotalRecords] = useState(0);
const [totalPages, setTotalPages] = useState(1);



 const fetchZones = async (pageNo = 1) => {
  setLoading(true);
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      "https://sutmmg.codydeasoftech.in/api/zoneMasterList",
      {
        search: filters.searchText,
        page: pageNo,
        per_page: perPage,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setZones(res.data.data || []);
    setTotalRecords(res.data.total_records || 0);
    setPerPage(res.data.per_page || 10);
    setPage(res.data.page || 1);

    // 🔥 CALCULATE TOTAL PAGES
    setTotalPages(
      Math.ceil((res.data.total_records || 0) / (res.data.per_page || 10))
    );
  } catch (error) {
    console.error("Fetch Zones Error:", error);

    if (error.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      navigate("/suda/login");
    } else {
      Swal.fire("Alert!", "Failed to load zones", "error");
    }
  } finally {
    setLoading(false);
  }
};

const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};






useEffect(() => {
  fetchZones(1);
}, []);

  // 📌 Open Add Modal
//   const openAddModal = () => {
//     setShowModal(true);
//     setIsEdit(false);
//     setZoneName("");
//   };

//   // 📌 Open Edit Modal
//   const openEditModal = (id, name) => {
//     setShowModal(true);
//     setIsEdit(true);
//     setEditId(id);
//     setZoneName(name);
//   };

const handleSave = async () => {
  try {
const token = localStorage.getItem("token");

    if (!zoneName) {
      return Swal.fire("Warning!", "Zone name is required", "warning");
    }

    if (isEdit) {
      await axios.put(
        `${BASE_URL}/zones/${editId}`,
        { zone_name: zoneName },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      Swal.fire("Updated!", "Updated successfully", "success");
    } else {
      await axios.post(
        `${BASE_URL}/zones`,
        { zone_name: zoneName },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      Swal.fire("Saved!", "Added successfully", "success");
    }

    fetchZones();
    setShowModal(false);
  } catch (error) {
    console.error("Save Zone Error:", error);

    // ✅ 401 Unauthorized → Logout
    if (error.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      navigate("/suda/login");
    }

    // ✅ 422 Validation
    else if (error.response?.status === 422) {
      Swal.fire({
        title: "Validation Failed",
        text: error.response.data?.message || "Invalid input data",
        icon: "warning",
      });
    }

    // ✅ Other Server Errors
    else {
      Swal.fire("Alert!", "Operation failed. Try again.", "error");
    }
  }
};



const deleteZone = async (id) => {
  if (!window.confirm("Are you sure want to delete?")) return;

  try {
const token = localStorage.getItem("token");

    await axios.delete(`${BASE_URL}/zones/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    Swal.fire("Deleted!", "Zone deleted successfully", "success");

    fetchZones();
  } catch (error) {
    console.error("Delete Error:", error);

    if (error.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      navigate("/suda/login");
    } else {
      Swal.fire("Alert!", "Failed to delete zone", "error");
    }
  }
};

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>



      {/* 🔍 FILTER CARD */}
      <Card className="mb-4 border-0"
  style={{
    background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
    borderRadius: "14px",
    boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
  }}>
        <div
    className="px-4 py-3 text-white rounded-top"
    style={{
      background: "linear-gradient(90deg, #0D47A1, #1565C1)",
    }}
  >
    <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
      <i className="fa-solid fa-filter"></i> Zone Master
    </h5>
  </div>
  <Card.Body className="px-4 py-4">

    <Row className="align-items-center">
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold text-dark">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter zone..."
                value={filters.searchText}
                onChange={(e) => setFilters({ ...filters, searchText: e.target.value })}
                style={{
                borderRadius: "10px",
                border: "2px solid #1565C1",
                }}
              />
            </Form.Group>
          </Col>


          <Col md={4} className="d-flex gap-3 mt-3">
                  {/* SEARCH */}
                  <Button
                    className="w-50 fw-semibold text-white"
                    style={{
                      background: "#1565C1",
                      border: "none",
                      borderRadius: "10px",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                    onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                    onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}

                  >
                    <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                  </Button>

                  {/* RESET */}
                  <Button
                    className="w-50 fw-semibold text-white"
                    style={{
                      background: "#E53935",
                      border: "none",
                      borderRadius: "10px",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                    onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                                  onClick={() => { setFilters({ searchText: "" }); fetchZones(); }}

                  >
                    <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                  </Button>
                </Col>
        </Row>
          </Card.Body>

      </Card>

       {/* <Button
        className="mb-3 px-4 text-white fw-semibold"
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          border: "none",
          borderRadius: "10px",
          padding: "10px 22px",
          boxShadow: "0 6px 15px rgba(46,125,50,0.4)",
          transition: "0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #1B5E20, #2E7D32)";
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow =
            "0 10px 22px rgba(46,125,50,0.55)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #2E7D32, #66BB6A)";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow =
            "0 6px 15px rgba(46,125,50,0.4)";
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Add Zone
      </Button> */}

      {loading && (
  <div className="loader-wrapper">
    <div className="blue-spinner"></div>

    <div className="loading-line">
      <div className="loading-progress"></div>
    </div>

    <p className="loading-text">Loading, please wait...</p>
  </div>
)}


      {/* 📄 TABLE */}
      {!loading && (
      <Card className="mb-4 border-0"
              style={{
                  background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
                  boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
                  overflow: "hidden",
              }}>
              <Table bordered hover responsive striped>
          <thead className="text-white" >
            <tr>
              <th style={{
        padding: "5px",
        fontWeight: "600",
        letterSpacing: "0.5px",
        borderTopLeftRadius: "10px",
        backgroundColor: "#edf7fe",
        height: "10px",
        borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign:"center"


      }}>SL No.</th>
              <th style={{
        padding: "5px",
        fontWeight: "600",
        letterSpacing: "0.5px",
        borderTopLeftRadius: "10px",
        backgroundColor: "#edf7fe",
        height: "10px",
        borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign:"center"


      }}>Zone Name</th>
              <th style={{
        padding: "5px",
        fontWeight: "600",
        letterSpacing: "0.5px",
        borderTopLeftRadius: "10px",
        backgroundColor: "#edf7fe",
        height: "10px",
        borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign:"center"


      }}>Action</th>
            </tr>
          </thead>

          <tbody>
            {zones.length > 0 ? zones.map((row, index) => (
              <tr key={row.id}>
                <td className="text-center">{index + 1}</td>
                <td className="text-center">{row.zone_name}</td>

                <td className="text-center">


                  <Button
                              size="sm"
                              className="me-2"
                              style={{
                                background: "#1565C1",
                                border: "none",
                                padding: "6px 10px",
                                boxShadow: "0 3px 8px rgba(21,101,193,0.3)",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background = "#0D47A1")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background = "#1565C1")
                              }
                                                onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}

                            >
                              <i className="fa-solid fa-pen text-white"></i>
                            </Button>

                            {/* DELETE */}
                            <Button
                              size="sm"
                              style={{
                                background: "linear-gradient(90deg, #E53935, #D32F2F)",
                                border: "none",
                                padding: "6px 10px",
                                boxShadow: "0 3px 8px rgba(229,57,53,0.4)",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background =
                                  "linear-gradient(90deg, #D32F2F, #B71C1C)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background =
                                  "linear-gradient(90deg, #E53935, #D32F2F)")
                              }
                                                  onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}

                            >
                              <i className="fa-solid fa-trash-can text-white"></i>
                            </Button>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="4" className="text-center text-muted py-4">No Data Found</td>
              </tr>
            )}
          </tbody>

        </Table>

       {totalPages > 1 && (

         <div className="d-flex justify-content-center mt-4">
  <nav>
    <ul className="pagination shadow-sm">

      {/* First */}
      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => fetchZones(1)}>
          «
        </button>
      </li>

      {/* Prev */}
      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => fetchZones(page - 1)}>
          ‹
        </button>
      </li>

      {/* Page Numbers */}
      {getPageNumbers().map((p) => (
        <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
          <button className="page-link" onClick={() => fetchZones(p)}>
            {p}
          </button>
        </li>
      ))}

      {/* Next */}
      <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => fetchZones(page + 1)}>
          ›
        </button>
      </li>

      {/* Last */}
      <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
        <button className="page-link" onClick={() => fetchZones(totalPages)}>
          »
        </button>
      </li>

    </ul>
  </nav>
</div>
       )}

      </Card>
      )}

      {/* ➕ / ✏ MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered  backdrop="static"
  keyboard={false} >
        <Modal.Header closeButton style={{ backgroundColor: "#3399ff", color: "white" }}>
          <Modal.Title>{isEdit ? "Edit Zone" : "Add New Zone"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Zone Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter zone name..."
              value={zoneName}
              onChange={(e) => setZoneName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="success" className="text-white" onClick={handleSave}>
            {isEdit ? "Update" : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default ZoneMaster;
